<template>
    <div class="loader" >
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="lds-microsoft" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background: none;"><g transform="rotate(0)"><circle cx="73.801" cy="68.263" fill="#3e92c8" r="2" transform="rotate(304.722 50 50)">
            <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4s" begin="0s"/>
        </circle><circle cx="68.263" cy="73.801" fill="#2b72a6" r="2" transform="rotate(321.913 50 50)">
            <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4s" begin="-0.062s"/>
        </circle><circle cx="61.481" cy="77.716" fill="#1d5686" r="2" transform="rotate(335.544 50 50)">
            <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4s" begin="-0.125s"/>
        </circle><circle cx="53.916" cy="79.743" fill="#12406b" r="2" transform="rotate(345.575 50.0001 50.0001)">
            <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4s" begin="-0.187s"/>
        </circle><circle cx="46.084" cy="79.743" fill="#0a3056" r="2" transform="rotate(352.77 50.0003 50.0003)">
            <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4s" begin="-0.25s"/>
        </circle><circle cx="38.519" cy="77.716" fill="#052140" r="2" transform="rotate(357.292 49.9999 49.9999)">
            <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4s" begin="-0.312s"/>
        </circle><circle cx="31.737" cy="73.801" fill="#021029" r="2" transform="rotate(359.609 50.0001 50.0001)">
            <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4s" begin="-0.375s"/>
        </circle><circle cx="26.199" cy="68.263" fill="#020611" r="2" transform="rotate(0.123571 50 50)">
            <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4s" begin="-0.437s"/>
        </circle><animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;0 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4s"/></g></svg>
    </div>
</template>

<script>
    export default {
        name: "loading-screen",
        computed: {},
        methods: {}
    }
</script>

<style scoped>

    .loader {
        width: 100%;
        height: 100%;
        position: fixed;
        background: rgba(255, 255, 255, 0.5);
    }

    .loader svg {
        left: 50%;
        top: 50%;
        position: fixed;
        margin-left: -128px;
        margin-top: -128px;
        width:256px;
        height:256px;
    }
</style>